'use client';

import { useTranslations } from '@/app/providers';
import { useEffect, useRef, useState } from 'react';

const Philosophy = () => {
  const t = useTranslations();
  const sectionRef = useRef<HTMLElement>(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Start revealing when section enters viewport, complete when it reaches top third
      const start = windowHeight;
      const end = windowHeight * 0.3;
      const current = rect.top;
      
      const progress = Math.min(1, Math.max(0, (start - current) / (start - end)));
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial check
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Split text into words for the reveal effect
  const words1 = t.philosophy.part1.split(' ');
  const words2 = t.philosophy.part2.split(' ');
  const totalWords = words1.length + 1 + words2.length; // +1 for the </> symbol

  const getWordStyle = (wordIndex: number) => {
    const wordProgress = wordIndex / totalWords;
    const isRevealed = scrollProgress > wordProgress;
    
    return {
      color: isRevealed ? 'white' : 'rgba(255, 255, 255, 0.2)',
      transition: 'color 0.3s ease-out',
    };
  };

  return (
    <section ref={sectionRef} className='container mx-auto px-6 mt-16 md:mt-0'>
      <p className='max-w-210.5 text-[2rem] md:text-[2.5rem] font-normal leading-[150%] pr-10 md:pr-30'>
        {words1.map((word, i) => (
          <span key={i} style={getWordStyle(i)}>
            {word}{' '}
          </span>
        ))}
        <br />
        <span 
          className='text-[2rem] font-semibold leading-[150%] transition-colors duration-300 ease-out'
          style={{
            color: scrollProgress > (words1.length / totalWords) ? 'var(--brand-violet-500)' : 'color-mix(in oklch, var(--brand-violet-500) 20%, transparent)',
          }}
        >
          {'</>'}
        </span>{' '}
        {words2.map((word, i) => (
          <span key={i} className='font-semibold' style={getWordStyle(words1.length + 1 + i)}>
            {word}{' '}
          </span>
        ))}
      </p>
    </section>
  );
};

export default Philosophy;


